import { CatalogItem } from '~/features/catalog/models/catalog-item';
import { CatalogSearchItem } from '~/features/catalog/models/catalog-search-result';

export function getFormalDegreeKey(item: CatalogItem | CatalogSearchItem): string | undefined {
  if (item.slug === 'mba-ai-product-management') return 'mba_ai';
  if (item.slug === 'masters-artificial-intelligence') return 'ms_ai';
  return undefined;
}
